import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@flexibilitypay/ui';

import type { CuentaByCuit } from '../../api/balance.api';

interface AccountSelectorProps {
  cuentas: CuentaByCuit[];
  onSelect: (cuenta: CuentaByCuit) => void;
}

export function AccountSelector({ cuentas, onSelect }: AccountSelectorProps) {
  const { t } = useTranslation(['accounts']);

  if (cuentas.length === 0) {
    return (
      <Card data-testid="account-selector-empty">
        <CardContent>
          <p className="text-sm text-muted-foreground">{t('accounts:search.empty')}</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card data-testid="account-selector">
      <CardHeader>
        <CardTitle className="text-base">{t('accounts:search.resultsTitle')}</CardTitle>
        <CardDescription>{cuentas.length}</CardDescription>
      </CardHeader>
      <CardContent className="px-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="pl-6">{t('accounts:search.columns.cvu')}</TableHead>
              <TableHead>{t('accounts:search.columns.alias')}</TableHead>
              <TableHead>{t('accounts:search.columns.estado')}</TableHead>
              <TableHead className="pr-6 text-right">
                {t('accounts:search.columns.actions')}
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {cuentas.map((c) => {
              const navegable = !!c.idCuenta;
              return (
                <TableRow key={c.cvu}>
                  <TableCell className="pl-6 font-mono text-xs">{c.cvu}</TableCell>
                  <TableCell>{c.alias}</TableCell>
                  <TableCell className="text-muted-foreground">{c.estado}</TableCell>
                  <TableCell className="pr-6 text-right">
                    <Button
                      variant="outline"
                      size="sm"
                      disabled={!navegable}
                      title={
                        navegable
                          ? undefined
                          : t('accounts:search.viewBalanceUnavailable')
                      }
                      onClick={() => navegable && onSelect(c)}
                    >
                      {t('accounts:search.viewBalance')}
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
